import { render } from "./ReceiptList.vue?vue&type=template&id=fdba1fc4&scoped=true"
import script from "./ReceiptList.vue?vue&type=script&lang=js"
export * from "./ReceiptList.vue?vue&type=script&lang=js"

import "./ReceiptList.vue?vue&type=style&index=0&id=fdba1fc4&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdba1fc4"]])

export default __exports__